export { default, StyledText } from './Text';
export type { TextProps } from './Text';
